import { Component } from '@angular/core'

@Component({
    selector: 'app-loading-circle',
    templateUrl: './loading-circle.component.html',
    styleUrls: ['./loading-circle.component.scss'],
})
export class loadingCircleComponent {
    constructor() {}
}
